import { faDiscord, faGithub, faLinkedinIn, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

export const ContactLinks = {
  linkedin: {
    href: 'https://www.linkedin.com/company/easworks/',
    icon: faLinkedinIn,
    label: 'LinkedIn',
  },
  twitter: {
    href: 'https://twitter.com/easihub',
    icon: faTwitter,
    label: 'Twitter'
  },
  discord: {
    href: 'https://discord.gg/easihub',
    icon: faDiscord,
    label: 'Discord'
  },
  github: {
    href: 'https://github.com/easihub',
    icon: faGithub,
    label: 'GitHub'
  },
  email: {
    href: 'mailto:hello@easihub.com',
    icon: faEnvelope,
    label: 'Email',
    text: 'hello@easihub.com'
  },
  phone1800: {
    href: 'tel: +1 (800) EASIHUB',
    icon: faPhone,
    label: 'Phone',
    text: '+1 (800) EASIHUB'
  }
} as const;